import {action, makeAutoObservable, observable, runInAction} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {ILeaguesStore} from "data/stores/leagues/leagues.store";
import {RequestState} from "data/enums";
import {createFanHubEvent} from "data/utils/helpers";

export interface IJoinLeaguesListItemController extends ViewController {
	requestState: RequestState;
	joinLeague: (code: string) => void;
}

@injectable()
export class JoinLeaguesListItemController implements IJoinLeaguesListItemController {
	@observable requestState: RequestState = RequestState.IDLE;

	constructor(@inject(Bindings.LeaguesStore) private _leaguesStore: ILeaguesStore) {
		makeAutoObservable(this);
	}

	dispose(): void {
		return;
	}

	@action
	public joinLeague = (code: string): void => {
		createFanHubEvent("66b953ae-df96-4517-94a2-fce4afec65e0");

		this.requestState = RequestState.PENDING;
		this._leaguesStore
			.joinLeague(code)
			.then(() => {
				createFanHubEvent("f8bd5646-22df-4e77-bf7e-2eab32e86bdc");
			})
			.finally(this.onFinally);
	};

	private onFinally = () => {
		runInAction(() => {
			this.requestState = RequestState.SUCCESS;
		});
	};

	init(param: void): void {
		this.requestState = RequestState.IDLE;
	}
}
